import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import CookieManager from "../services/cookie-manager";
import CacheManager from "../services/cache-manager";

export default class LocalstorageFieldPopulationBehaviour extends AbstractDataAttributeBehaviour {
    attrInput = 'data-value-from-localstorage';
    cacheManager = new CacheManager();
    
    getContainerSelector()
    {
        return '[' + this.attrInput + ']';
    }

    initContainer(container)
    {
        let key = container.getAttribute(this.attrInput);
        let value = this.cacheManager.getItem(key);
        if (value) container.value = value;
    }
}

